import React from 'react';
import Footer from '../main/body/screens/Login/Components/Footer/Footer';
import Content from '../main/body/screens/Login/Components/Content/Content';
import Header from '../main/body/screens/Login/Components/Header/Header';

const Login = () => {
    return (
        <div>
             <Header />
            <Content />
            <Footer />
        </div>
    );
}

export default Login;
